module.exports = __webpack_public_path__ + "img/au-wa.54380058.svg";